/*
 *                     NOTICE
 *            COPYRIGHT 2024 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbstractOperandValueImpl, AbstractOperandValueImplBaseRecordClassFactory } from "abreact/expression/ui/editor/impl/model/impl/row/operandValue/AbstractOperandValueImplBaseRecordClassFactory";
import { NullUtils } from "abweb/utils/NullUtils";
import Immutable from "immutable";
// import ValueCategoryAndType = Expression.Domain.ValueCategoryAndType;
// import WithoutNodeType = GuidedExpressionEditor.AbstractModel.AbstractRowModel.AbstractOperandValue.WithoutNodeType;
// import AbstractStandardOperandValue = GuidedExpressionEditor.AbstractModel.AbstractRowModel.AbstractStandardOperandValue;

export class AbstractStandardOperandValueImplBaseRecordClassFactory {
  /* eslint-disable-next-line abinitio/type-declaration */
  createBaseRecordClass(defaultState) {
    class AbstractStandardOperandValueImpl extends new AbstractOperandValueImplBaseRecordClassFactory().createBaseRecordClass(defaultState) {
      withValueCategoryID(valueCategoryID) {
        return this.with({
          valueCategoryID
        });
      }
      withValueTypeIDs(valueTypeIDs) {
        return this.with({
          valueTypeIDs
        });
      }
      withValueCategoryAndType(valueCategoryAndType) {
        return this.with({
          valueCategoryID: valueCategoryAndType.valueCategoryIDOrThrow,
          valueTypeIDs: Immutable.List.of(NullUtils.getRequiredPropertyValue(valueCategoryAndType.valueTypeWithCardinality, "valueTypeID")),
          multiple: NullUtils.getRequiredPropertyValue(valueCategoryAndType.valueTypeWithCardinality, "multiple")
        });
      }
      withDisplayValue(displayValue) {
        return this.with({
          displayValue
        });
      }
      withTypeQualifier(typeQualifier) {
        return this.with({
          typeQualifier
        });
      }
      stateWithoutNodeType() {
        return {
          ...super.stateWithoutNodeType(),
          valueCategoryID: this.valueCategoryID,
          valueTypeIDs: this.valueTypeIDs,
          multiple: this.multiple,
          displayValue: this.displayValue,
          typeQualifier: this.typeQualifier
        };
      }
      toExpExpressionNode() {
        return {
          ...super.toExpExpressionNode(),
          categoryID: this.valueCategoryID,
          valueTypeIDs: this.valueTypeIDs.toArray(),
          multiple: this.multiple,
          displayValue: this.displayValue,
          typeQualifier: this.typeQualifier
        };
      }
    }
    return AbstractStandardOperandValueImpl;
  }
}
export let AbstractStandardOperandValueImpl;
(function (_AbstractStandardOperandValueImpl) {
  function getDefaultState() {
    return {
      ...AbstractOperandValueImpl.getDefaultState(),
      expExpressionNodeNodeType: undefined,
      valueCategoryID: undefined,
      // Defined in constructor
      valueTypeIDs: undefined,
      // Defined in constructor
      multiple: undefined,
      // Defined in constructor
      displayValue: undefined,
      typeQualifier: undefined
    };
  }
  _AbstractStandardOperandValueImpl.getDefaultState = getDefaultState;
})(AbstractStandardOperandValueImpl || (AbstractStandardOperandValueImpl = {}));
//# sourceMappingURL=AbstractStandardOperandValueImplBaseRecordClassFactory.js.map
